import { rei } from "@/services/api"
import http from 'http'
import https from 'https'

class SeadeService {
  static index (params) {
    const httpAgent = new http.Agent({ keepAlive: true })
    const httpsAgent = new https.Agent({ keepAlive: true })

    return rei.get(`seade`, {params: params}, {httpAgent}).then(res => res.data)
  }

  static gerarTxt (params) {
    return rei.post(`download-txt-registros`, { ...params }).then(res => res)
  }
}

export default SeadeService
